import Character from "../../../lib/services/scene/character";
import { PuppyClips }from "./puppy_clips"
import ResourceService from "../../../lib/services/resource/resourceservice";
import ShaderService from "../../../lib/services/shader/shader_service";

export default class PuppyCharacter extends Character
{

    constructor()
    {
      super("puppychar","puppy","puppy","puppy_rm","papercraft_skinned",PuppyClips.Sitting_loop_1);
      this.transform.set_scale(1, 1, 1);
      this.transform.set_position(-0.1, 0, 4.9);
      this.transform.set_rotation(0, 0, 0);
      this.transform.update_matrix();
         
    }

    override async build(
            device: GPUDevice,
            format: GPUTextureFormat,
            shader_service: ShaderService,
            resource_service: ResourceService
          ): Promise<void> 
          {
            
            const p = await super.build(device,format,shader_service,resource_service);
            this.log_animations();
            return p;
          }

    override tick(delta_time: number): void 
    {
        super.tick(delta_time);
    }

    ui_message(cmd: string, msg: string): void {
    super.ui_message(cmd, msg);
  }
   


}